export default __webpack_public_path__ + "static/media/imgpost12.a446acda.jpg";